import { render, staticRenderFns } from "./OrderLogistic.vue?vue&type=template&id=c70485bc&scoped=true&"
import script from "./OrderLogistic.vue?vue&type=script&lang=js&"
export * from "./OrderLogistic.vue?vue&type=script&lang=js&"
import style0 from "./OrderLogistic.vue?vue&type=style&index=0&id=c70485bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70485bc",
  null
  
)

export default component.exports